import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import PropTypes from 'prop-types';
import useChartUpdate from '../UseChartUpdate';

var Credits = function Credits(_ref) {
  var _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      restProps = _objectWithoutProperties(_ref, ["enabled"]);

  useChartUpdate(_objectSpread({
    enabled: enabled
  }, restProps), updateCredits, function (chart) {
    return updateCredits(chart, {
      enabled: false
    });
  });
  return null;
};

var updateCredits = function updateCredits(chart, config) {
  // Use default Highcharts value if text is not explicitly set
  if ('text' in config && !config.text) delete config.text;
  chart.addCredits(config, true);
};

Credits.propTypes = {
  enabled: PropTypes.bool
};
export default Credits;